import type { ActionStatusModel } from '@/features/Actions/model/types/actions-status.model';
import type { UserModel } from '@/features/Shared/users/model/types/users.model';

export const useRecipientStatus = (
	id: string,
	actionsStatusMap: Record<string, ActionStatusModel>,
	users: Record<string, UserModel>
) => {
	const resolvedRecipientGroups = actionsStatusMap[id]?.resolvedRecipientGroups;

	const matchUserIdToStatus = (userId: string) => {
		if (acceptedUserIds.includes(userId)) return 'accepted';
		if (declinedUserIds.includes(userId)) return 'declined';
		if (receivedUserIds.includes(userId)) return 'received';
		if (sentUserIds.includes(userId)) return 'sent';
		return 'not-sent';
	};

	const acceptedUserIds = actionsStatusMap[id]?.acceptedUserIds ?? [];
	const declinedUserIds = actionsStatusMap[id]?.declinedUserIds ?? [];
	const receivedUserIds = actionsStatusMap[id]?.receivedUserIds ?? [];
	const sentUserIds = actionsStatusMap[id]?.sentUserIds ?? [];

	const sortByStatus = (a: { status: string }, b: { status: string }) => {
		const statusOrder = ['accepted', 'declined', 'received', 'sent', 'not-sent'];
		return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
	};

	const items =
		resolvedRecipientGroups?.map((group) => ({
			groupNumber: group.groupNumber,
			recipients: group.recipients
				.map((recipient) => ({
					id: recipient.id,
					name: `${users[recipient.id]?.firstName ?? ''} ${users[recipient.id]?.lastName ?? ''}`.trim(),
					status: matchUserIdToStatus(recipient.id),
				}))
				.sort(sortByStatus),
		})) ?? [];

	return { items };
};
